
const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/3672abc50ccf6079ccd4d8c3c02f5930.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Advanced <span className="text-teal-400">Chemical Solutions</span><br />
          for Oil & Gas Industry
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-200">
          Leading innovation-driven provider delivering sustainable, customized formulations 
          with 20+ expert engineers specializing in upstream interventions and corrosion mitigation.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="/solutions" 
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore Solutions
          </a>
          <a 
            href="/contact" 
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Experts
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
